/** @format */
import {MouseEvent, ReactNode, useEffect, useRef, useState} from 'react';

import {Box, Popper} from '@mui/material';

import {DEFAULT_DELAY} from './constants';
import {StyledPaper} from './styles';

interface Props {
  PopperContent?: ReactNode;
  children: ReactNode;
  delay?: number;
}

const HintPopper = ({PopperContent, children, delay}: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);

  const hoverTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const open = Boolean(anchorEl);

  const clearHoverTimer = () => {
    if (hoverTimer.current) {
      clearTimeout(hoverTimer.current);
      hoverTimer.current = null;
    }
  };

  const onMouseEnter = (e: MouseEvent<HTMLDivElement>) => {
    const target = e.currentTarget;
    hoverTimer.current = setTimeout(() => {
      setAnchorEl(target);
    }, delay ?? DEFAULT_DELAY);
  };

  const onMouseLeave = () => {
    clearHoverTimer();
    setAnchorEl(null);
  };

  useEffect(() => {
    return () => {
      clearHoverTimer();
    };
  }, []);

  if (!PopperContent) {
    return children;
  }

  return (
    <>
      <Box onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        {children}
      </Box>
      <Popper
        open={open}
        anchorEl={anchorEl}
        placement='bottom-start'
        sx={{
          pointerEvents: 'none',
        }}
      >
        <StyledPaper>{PopperContent}</StyledPaper>
      </Popper>
    </>
  );
};

export {HintPopper};
